'use client'

import { Dialog } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'
import {
  markAsDelivered,
  clickEvent,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'

type Props = {
  transactionId: number
  shipmentId: number
  isOpen: boolean
  onClose: () => void
  screen: string
  userSide?: TransactionSide | null
}

const MarkAsReceivedConfirmationModal = ({
  transactionId,
  shipmentId,
  isOpen,
  onClose,
  screen,
  userSide,
}: Props) => {
  const { track } = useTracking()

  const isBuyer = userSide === TransactionSide.Buyer
  const translationPrefix = isBuyer
    ? 'conversation.tracking_details.mark_as_received_confirmation'
    : 'conversation.tracking_details.mark_as_received_confirmation.seller'

  const translate = useTranslate(translationPrefix)

  function trackMarkAsDeliveredClick() {
    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        screen,
        target: 'mark_as_received',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  async function handleMarkAsDeliveredClick() {
    await markAsDelivered(shipmentId)
    trackMarkAsDeliveredClick()
    onClose()
    reloadPage()
  }

  return (
    <Dialog
      show={isOpen}
      defaultCallback={onClose}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('confirm'),
          callback: handleMarkAsDeliveredClick,
          style: Dialog.ActionStyling.Filled,
          testId: 'mark-as-received-confirmation-modal-confirm',
        },
        {
          text: translate('close'),
          callback: onClose,
          style: Dialog.ActionStyling.Flat,
        },
      ]}
    />
  )
}

export default MarkAsReceivedConfirmationModal
